<template>
  <div>
    <nav-breadcrumb :menu="[{label :'发起用款申请'}]"/>
    <el-form label-width="170px" class="xzformitemmb" :model="financingDetail" ref="dataForm">
      <el-row>
        <panel title="贷款信息" border>
          <el-col :span="12">
            <el-form-item label="贷款编号 ：">
              {{financingDetail.fi__transactionNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款状态：">
              {{'Financing_'+ financingDetail.fi__transactionStatus|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称：">
              {{financingDetail.fi__customerName}}
            </el-form-item>
            <el-form-item label="贷款金额：">
              {{financingDetail.fi__totalAmount|formatMoney}} 元
            </el-form-item>
            <el-form-item label="贷款开始日期：">
              {{financingDetail.fi__startDate|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="贷款合同利率：">
              {{financingDetail.fi__interestRate|formatMoney}}% （{{financingDetail.fi__interestType|Status2CN}}）
            </el-form-item>
            <el-form-item label="贷款合同月利率：">
              {{financingDetail.monthRate}}‰
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道商：">
              {{financingDetail.d__dealerName}}
            </el-form-item>
            <el-form-item label="贷款产品：">
              {{financingDetail.ct__productName}}
            </el-form-item>

            <el-form-item label="贷款结束日期：">
              {{financingDetail.fi__endDate|moment('YYYY-MM-DD')}}
            </el-form-item>

            <el-form-item label="留存收益率：">
              {{financingDetail.dfi__interestRate|formatMoney}}% （{{financingDetail.dfi__interestType|Status2CN}}）
            </el-form-item>
            <el-form-item label="还款期数（月）：">
              {{financingDetail.fi__repaymentCount}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="还款方式：">
              {{financingDetail.fi__repaymentFormula|Status2CN}}
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">
            <el-form-item label="抵押房产：">
              {{financingDetail.ex__propertyLocation}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="他项权证号：" prop="fidoc__hisWarrantNo" :rules="{required: true, message: '他项权证号不能为空'}" >
              <el-input v-model="financingDetail.fidoc__hisWarrantNo" style="width: 30%"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="24">
            <el-form-item label="贷款用途：" >
              {{financingDetail.fi__intendedUse}}
            </el-form-item>
          </el-col>
        </panel>
        <panel title="放款信息" border>
          <el-col :span="12">
            <el-form-item label="收款账号：">
              {{financingDetail.cb__accountNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户名：">
              {{financingDetail.cb__accountName}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="开户行：">
              {{financingDetail.cb__bank}}
            </el-form-item>
          </el-col>
          <!--<el-col :span="12">
            <el-form-item label="放款方式：" prop="pay__channel" :rules="{required: true, message: '放款方式不能为空'}" style="width: 60%">
              <el-select placeholder="请选择放款方式" v-model.trim="financingDetail.pay__channel" >
                <el-option label="通联支付" value="TLT"></el-option>
                <el-option label="网银转账" value="BANKTRANSFER"></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="申请放款金额：">
              {{financingDetail.fi__totalAmount|formatMoney}} 元
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="申请放款日期：" prop="pay__paymentDate" :rules="{required: true, message: '日期不能为空'}" >
              <el-date-picker
                v-model="financingDetail.pay__paymentDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </panel>
        <panel label="房屋信息">
            <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in financingDetail.properties" :key="idx" >
                <form-build
                    :form-data="item"
                    :form-rules="financingRules"
                    :form-columns="houseColumns"
                    class="formTable"
                />
                <br/>
                <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.doc__hisWarrant" prefix="images/" required></image-upload>
                    <label>他项权证<span class="color-danger">*</span></label>
                </div>

            </panel>

        </panel>
        <panel label="相关材料" class="zhengjianxinxi">
          <div class="zhenjianyyzz zhenjianyyzz2">
            <image-upload  v-model="financingDetail.fidoc__dealerLetter" prefix="images/" required></image-upload>
            <label>渠道推荐函<span class="color-danger" v-if="financingDetail.d__dealerTypeId!='DT-A'">*</span></label>
          </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
            <file-upload  v-model="financingDetail.fidoc__signedContract" prefix="images/" required></file-upload>
            <label>签约后的借款合同<span class="color-danger">*</span></label>
          </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
            <file-upload  v-model="financingDetail.fidoc__pledgeExContract" prefix="images/" ></file-upload>
            <label>一抵信息</label>
          </div>
            <div class="zhenjianyyzz zhenjianyyzz2">
                <file-upload  v-model="financingDetail.fidoc__pledgeContract" prefix="images/" ></file-upload>
                <label>抵押合同</label>
            </div>
            <div class="zhenjianyyzz zhenjianyyzz2">
                <file-upload  v-model="financingDetail.fidoc__otherDoc" prefix="images/" ></file-upload>
                <label>其他</label>
            </div>
        </panel>
        <panel border>
          <el-col :span="24">
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="financingDetail.pay__remarks" style="margin-bottom:10px;"></el-input>
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "LoanApprove",
      data() {
        return {
          financingRules:{
              doc__hisWarrantNo: [
                  {
                      required: true,
                      message: '他项权证号不能为空！'
                  }
              ],
          },
          financingDetail: {
            monthRate:'',
          },
          houseColumns:[
            {
              label: '抵押房产',
              field: 'pr__propertyLocation',

            },
            {
              label: '他项权证号',
              component: 'el-input',
              field: 'doc__hisWarrantNo',

            },
          ],
        }
      },
      filters: {

        Status2CN
      },
      mounted(){
        this.getData()
      },
      methods:{
        getData:function () {
            xhr.getFinancingFang({
                'fi.transactionId': this.$route.query['transactionId']
              },
              res => {
                try {
                  if (res.data.status == 'success') {
                    this.financingDetail = res.data.data

                    if(this.financingDetail.ct__interestType == 'Yearly'){
                      this.financingDetail.monthRate = (this.financingDetail.fi__interestRate/12)
                    }
                    if(this.financingDetail.ct__interestType == 'Monthly'){
                      this.financingDetail.monthRate = this.financingDetail.fi__interestRate
                    }if(this.financingDetail.ct__interestType == 'Daily'){
                      this.financingDetail.monthRate = (this.financingDetail.fi__interestRate*30)
                    }

                    this.financingDetail.monthRate = parseFloat((parseFloat(this.financingDetail.monthRate)*10).toFixed(3))

                  }
                } catch (e) {

                }
              })
          },
        onSubmit:function (formName) {
          this.$refs[formName].validate(valid=> {
            if (valid) {
              if(!(
                this.financingDetail.fidoc__signedContract)){
                this.$alert('有必填的图片或文件未上传')
                return false
              }
              if(this.financingDetail.d__dealerTypeId!='DT-A'){
                  if(this.financingDetail.fidoc__dealerLetter){

                  }else{
                      this.$alert('推荐函必填')
                      return false
                  }
              }
              let count = 1
              let valid1 = true
              this.financingDetail.properties.forEach(item=>{
                    if(valid1){
                        if(item.doc__hisWarrantNo){

                        }else{
                            this.$alert('抵押物'+count+'他项权证号未填写')

                            valid1= false
                        }
                        if(item.doc__hisWarrant){

                        }else{
                            this.$alert('抵押物'+count+'他项权证图片不能为空')

                            valid1= false
                        }
                    }
                  count++
              })
              let onSubmitFrom = {
              }
              onSubmitFrom.pay__transactionId = this.financingDetail.fi__transactionId
              onSubmitFrom.pay__paymentDate = this.financingDetail.pay__paymentDate
              onSubmitFrom.fidoc__hisWarrant = this.financingDetail.fidoc__hisWarrant
              onSubmitFrom.fidoc__dealerLetter = this.financingDetail.fidoc__dealerLetter
              onSubmitFrom.fidoc__signedContract = this.financingDetail.fidoc__signedContract
              onSubmitFrom.pay__channel = this.financingDetail.pay__channel
              onSubmitFrom.fidoc__hisWarrantNo = this.financingDetail.fidoc__hisWarrantNo
              onSubmitFrom.fidoc__pledgeExContract = this.financingDetail.fidoc__pledgeExContract
              onSubmitFrom.fidoc__pledgeContract = this.financingDetail.fidoc__pledgeContract
              onSubmitFrom.fidoc__otherDoc = this.financingDetail.fidoc__otherDoc
              onSubmitFrom.pay__remarks = this.financingDetail.pay__remarks ||''
              onSubmitFrom.properties = this.financingDetail.properties
              if(valid1){
                  xhr.createFinancingPaymentForApproval(onSubmitFrom, res=> {
                      try {
                          if (res.data.status == 'success') {

                              this.$router.push({
                                  path: 'List'
                              })
                          }
                      } catch (e) {
                      }
                  })
              }

            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LoanApprove.vue